module.exports = __webpack_public_path__ + "91d8319e90ebe38af254ba4f65763a1b.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/close-icon.png
// module id = 62
// module chunks = 0